/**
 * Anthropic icon (Claude).
 */
export const ANTHROPIC_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
<rect width="48" height="48" fill="#F0EFEA"/>
<path d="M32.84 10H26.72L37.88 38H44L32.84 10Z" fill="black"/>
<path d="M15.16 10L4 38H10.24L12.5224 32.12H24.1976L26.48 38H32.72L21.56 10H15.16ZM14.5408 26.92L18.36 17.08L22.1793 26.92H14.5408Z" fill="black"/>
</svg>`;

/**
 * Convert SVG string to data URI for use in img src.
 */
export function svgToDataUri(svg: string): string {
  const encoded = encodeURIComponent(svg)
    .replace(/'/g, '%27')
    .replace(/"/g, '%22');
  return `data:image/svg+xml,${encoded}`;
}

function normalizeIcon(icon: string): string {
  if (icon.startsWith('data:') || icon.endsWith('.svg') || icon.includes('.svg?')) {
    return icon;
  }
  return svgToDataUri(icon);
}

/**
 * Get the Anthropic icon as a data URI.
 */
export function getAnthropicIconDataUri(): string {
  return normalizeIcon(ANTHROPIC_ICON);
}
